var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100.767,
    height: 111.22,
    viewBox: "0 0 100.767 111.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23866",
    "data-name": "Rectangle 23866",
    width: 91.872,
    height: 63.313,
    fill: "#fd930d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_69219",
    "data-name": "Group 69219",
    transform: "translate(45.936 111.22) rotate(-120)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69218",
    "data-name": "Group 69218",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_237317",
    "data-name": "Path 237317",
    d: "M.9,0A.9.9,0,0,0,.089.515a.893.893,0,0,0,.426,1.2L12.747,7.451a.9.9,0,0,0,.764-1.634L1.28.089A.792.792,0,0,0,.9,0",
    transform: "translate(71.11 8.872)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237318",
    "data-name": "Path 237318",
    d: "M.9,0A.931.931,0,0,0,.183.346.913.913,0,0,0,.344,1.609L23.326,19.417a.9.9,0,0,0,1.1-1.424L1.447.185A.916.916,0,0,0,.9,0",
    transform: "translate(67.089 17.007)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237319",
    "data-name": "Path 237319",
    d: "M.9,0A.946.946,0,0,0,.386.161.9.9,0,0,0,.161,1.416L7.886,12.5a.9.9,0,0,0,1.481-1.03L1.641.386A.912.912,0,0,0,.9,0",
    transform: "translate(60.923 24.064)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237320",
    "data-name": "Path 237320",
    d: "M.9,0A1.006,1.006,0,0,0,.564.064a.91.91,0,0,0-.5,1.175l11,26.909a.9.9,0,0,0,1.666-.684L1.739.563A.9.9,0,0,0,.9,0",
    transform: "translate(53.375 29.094)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237321",
    "data-name": "Path 237321",
    d: "M.9,0H.824A.912.912,0,0,0,0,.974L1.154,14.436a.912.912,0,0,0,.974.821.9.9,0,0,0,.821-.974L1.8.821A.9.9,0,0,0,.9,0",
    transform: "translate(44.512 32.127)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237322",
    "data-name": "Path 237322",
    d: "M4.828,0a.908.908,0,0,0-.893.781L.008,29.58a.9.9,0,1,0,1.786.241l3.927-28.8A.9.9,0,0,0,4.949.008L4.828,0",
    transform: "translate(31.536 32.707)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237323",
    "data-name": "Path 237323",
    d: "M6.635,0a.9.9,0,0,0-.813.515L.084,12.746a.9.9,0,1,0,1.634.764L7.447,1.279A.894.894,0,0,0,7.013.089.791.791,0,0,0,6.635,0",
    transform: "translate(20.532 30.896)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237324",
    "data-name": "Path 237324",
    d: "M18.705,0a.931.931,0,0,0-.716.346L.189,23.328a.9.9,0,1,0,1.424,1.1l17.8-22.982A.9.9,0,0,0,19.252.185.916.916,0,0,0,18.705,0",
    transform: "translate(0.334 26.873)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237325",
    "data-name": "Path 237325",
    d: "M11.98,0a.947.947,0,0,0-.515.161L.384,7.886A.91.91,0,0,0,.159,9.141a.9.9,0,0,0,1.255.225L12.495,1.642A.9.9,0,0,0,12.72.386.912.912,0,0,0,11.98,0",
    transform: "translate(0.002 20.717)",
    fill: "#fd930d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMise);
export default __webpack_public_path__ + "static/media/mise.a95425a29ae936afdd3ab12900dc313c.svg";
export { ForwardRef as ReactComponent };